export enum SettingsSubRoutes {
  GENERAL = "general",
  LANGUAGE = "language",
  NOTIFICATIONS = "notifications",
  FIELDS = "fields",
  MODULES = "modules",
  TAGS = "tags",
  APPEARANCE = "appearance",
  SECURITY_PASSWORD = "security-password",
  MANAGE_ACCOUNTS = "manage-accounts",
  AI_CHATBOT = "ai-chatbot",
}
